import React from 'react'
import { Separator } from '@fs/zion-ui'
import { css } from '@emotion/core'
import useIsMobile from '../hooks/useIsMobile'

const headerCss = css`
  font-size: 64px;
  font-weight: 700;
  line-height: 64px;
`

const subheaderCss = css`
  font-size: 24px;
  line-height: 34px;
  max-width: 780px;
  margin: 0 auto;
`

const mobileHeaderCss = css`
  font-size: 36px;
  line-height: 46px;
  font-weight: 700;
  margin-bottom: 8px;
  /* For very small resolutions, like the galaxy fold, we need to break on words */
  word-break: break-word;
`

const mobileSubheaderCss = css`
  font-size: 20px;
  line-height: 24px;
`

export default function PageBannerText({ heading, subheading }) {
  const isMobile = useIsMobile()

  return (
    <>
      {isMobile ? (
        <>
          <h1 css={mobileHeaderCss}>{heading}</h1>
          <p css={mobileSubheaderCss}>{subheading}</p>
        </>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <h1 css={headerCss}>{heading}</h1>
            <Separator />
            <p css={subheaderCss}>{subheading}</p>
          </div>
        </div>
      )}
    </>
  )
}
